import { create } from 'zustand';
import type { User } from '../lib/authClient.js';

interface Profile {
  lifeContext: string;
  workContext: string;
  currentFocus: string;
}

interface AuthState {
  user: User | null;
  isOperator: boolean;
  hasImplicitAccess: boolean;
  profile: Profile;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setIsOperator: (value: boolean) => void;
  setHasImplicitAccess: (value: boolean) => void;
  setProfile: (profile: Profile) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isOperator: false,
  hasImplicitAccess: false,
  profile: { lifeContext: '', workContext: '', currentFocus: '' },
  isLoading: true,
  setUser: (user) => set({ user }),
  setIsOperator: (isOperator) => set({ isOperator }),
  setHasImplicitAccess: (hasImplicitAccess) => set({ hasImplicitAccess }),
  setProfile: (profile) => set({ profile }),
  setLoading: (isLoading) => set({ isLoading }),
}));
